export default "__VITE_ASSET__DfnKxhha__"